import deepMerge from 'deepmerge';
import { omit } from 'lodash';

import customStyles from 'app/pipeline-details/shared/PipelineOverviewStaticTable/customStyles';

const additionalStyles = {
  rows: {
    style: {
      '&:first-of-type > div:last-of-type': {
        maxWidth: '110px',
      },
      '&:last-of-type > div:first-of-type': {
        width: '128px',
        maxWidth: '128px',
      },
    },
  },
};

const schemaEnforcementTableCustomStyles = deepMerge(omit(customStyles, 'cells'), additionalStyles);

export default schemaEnforcementTableCustomStyles;
